import { type FC } from "react";

import { CookiePopup } from "@snapchat/sc-web-frame";

import { GAID, GTMID } from "../../shared/constants";

interface CookiePopupWrapperProps {
    performanceAnalyticsCallback: () => void;
}

export const CookiePopupWrapper: FC<CookiePopupWrapperProps> = ({ performanceAnalyticsCallback }) => {
    return (
        <CookiePopup
            cookieSettingsUrl="https://www.snapchat.com/cookie-settings"
            cookieDomain="snapchat.com"
            performanceAnalyticsCallback={performanceAnalyticsCallback}
            GTMID={GTMID}
            GAID={GAID}
        />
    );
};
